/** PURE_IMPORTS_START .._.._Observable,.._.._operator_filter PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { filter } from '../../operator/filter';
Observable.prototype.filter = filter;
//# sourceMappingURL=filter.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/add/operator/filter.js
// module id = ./node_modules/rxjs/_esm5/add/operator/filter.js
// module chunks = vendor